module.exports = __webpack_public_path__ + "img/p2-p3-lubiao.37be2e83.png";